import axios from 'axios';

const API_BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  'https://manage-dev.hlthtek.com/app/api/';

export const OT_ROOM_CLASSIFICATION = 'OT Room Charges';
export const OT_SURGERY_CLASSIFICATION = 'OT Surgical Procedures';

const apiHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem('accessToken') || ''}`,
  'APP-MODE': sessionStorage.getItem('APP_MODE') || '',
  'ORG-CODE': sessionStorage.getItem('ORG_CODE') || '',
  'USER-ACCESS-KEY': sessionStorage.getItem('USER_ACCESS_KEY') || '',
  USERNAME: sessionStorage.getItem('userName') || '',
});

export function mapOtCatalogService(item) {
  const id = item?.medical_service_id ?? item?.id ?? null;
  if (id == null) return null;
  const fee = item?.fee ?? item?.rate ?? null;
  return {
    id: String(id),
    medical_service_id: String(id),
    name: item?.name || item?.term || 'Unnamed service',
    service_code: item?.service_code || item?.code || '',
    code: item?.service_code || item?.code || '',
    fee,
    rate: fee,
    unit: item?.unit || '',
    serviceType: item?.service_type || '',
    category: item?.service_classification_name || item?.classification_name || '',
    _raw: item,
  };
}

/** POST get_medical_services/ filtered by OT classification name (includes fee / unit). */
export async function searchOtCatalogServices({ classificationName, name = '', limit = 50 } = {}) {
  const query = name.trim();
  const response = await axios.post(
    `${API_BASE}get_medical_services/`,
    {
      classification_name: classificationName,
      ...(query ? { query } : {}),
    },
    { headers: { ...apiHeaders(), 'Content-Type': 'application/json' } },
  );
  let rows = Array.isArray(response?.data?.data)
    ? response.data.data
    : Array.isArray(response?.data?.service_list)
      ? response.data.service_list
      : [];
  if (query) {
    const q = query.toLowerCase();
    rows = rows.filter((row) => (
      String(row?.name || row?.term || '').toLowerCase().includes(q)
      || String(row?.service_code || '').toLowerCase().includes(q)
    ));
  }
  return rows.slice(0, limit).map(mapOtCatalogService).filter(Boolean);
}

export function durationUnitForApi(unit) {
  return unit === 'hour' ? 'HOUR' : 'MIN';
}

export function buildOtChargePayload({ room, duration, durationUnit, service, doctors }) {
  const charges = [];
  if (room?.service_code || room?.medical_service_id) {
    const charge = {
      duration: Number(duration),
      duration_unit: durationUnitForApi(durationUnit),
    };
    if (room.service_code) charge.service_code = room.service_code;
    else charge.medical_service_id = room.medical_service_id || room.id;
    charges.push(charge);
  }
  if (service?.service_code || service?.medical_service_id) {
    const billedDoctors = (doctors || []).filter(d => d.doctorId && Number(d.amount) > 0);
    const amount = billedDoctors.reduce((sum, d) => sum + Number(d.amount), 0);
    const charge = {
      amount: String(amount),
      metadata: {
        doctors: billedDoctors.map(d => ({
          doctor_id: d.doctorId,
          doctor_name: d.doctorName,
          department: d.department,
          amount: Number(d.amount),
        })),
      },
    };
    if (service.service_code) charge.service_code = service.service_code;
    else charge.medical_service_id = service.medical_service_id || service.id;
    charges.push(charge);
  }
  return charges.length ? { charges } : null;
}
